import { createIcon } from '@chakra-ui/icons';

const UpAndDownIcon = createIcon({
  displayName: 'UpAndDownIcon',
  viewBox: '0 0 12 12',
  path: (
    <path
      d="M2.66675 11.3334H4.00008V3.33335H6.00008L3.33341 0.666687L0.666748 3.33335H2.66675V11.3334ZM11.3334 8.66669H9.33341V0.666687H8.00008V8.66669H6.00008L8.66675 11.3334L11.3334 8.66669Z"
      fill="black"
    />
  ),
});

export default UpAndDownIcon;
